import { ErrorHandler, Injectable } from '@angular/core'

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    const message = `${error?.message ?? ''}`
    const name = `${error?.name ?? ''}`
    // Angular 20 + esbuild no longer emits the old webpack "Loading chunk N failed" text; a lazy
    // chunk that 404s after a deploy now surfaces as a dynamic-import failure or ChunkLoadError.
    const isChunkLoadError =
      /Loading chunk [\d]+ failed/i.test(message) ||
      /ChunkLoadError/i.test(name) ||
      /(error loading|failed to fetch) dynamically imported module/i.test(message) ||
      /Importing a module script failed/i.test(message)

    if (isChunkLoadError) {
      const RELOAD_KEY = 'chunkReloadAt'
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
      // Reload at most once per 10s so a genuinely missing chunk cannot cause an infinite reload loop.
      if (Date.now() - last > 10000) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
        window.location.reload()
        return
      }
    }

    super.handleError(error)
  }
}
